const CUSTOMER_SERVICE_URL = 'https://kf.app-lmaxex.top/chat/index?token=7ec81b52e44114148270f0558c355196'

function parseUserInfo(userInfo) {
  if (userInfo && typeof userInfo === 'object') return userInfo

  if (typeof userInfo === 'string' && userInfo) {
    const value = userInfo.trim()
    if (value.startsWith('{')) {
      try {
        return JSON.parse(value)
      } catch (error) {
        return { userName: value }
      }
    }
    return { userName: value }
  }

  const cachedUserInfo = localStorage.getItem('userInfo')
  if (!cachedUserInfo) return {}

  try {
    return JSON.parse(cachedUserInfo)
  } catch (error) {
    return {}
  }
}

export function getCustomerServiceUrl(userInfo) {
  const info = parseUserInfo(userInfo)
  const userName = info.userName || info.username || ''
  const url = new URL(CUSTOMER_SERVICE_URL)

  if (userName) url.searchParams.set('username', userName)

  return url.toString()
}

export function openCustomerService(userInfo) {
  window.location.href = getCustomerServiceUrl(userInfo)
}

